"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDeviceName = void 0;

var _const = require("../const");

var _useMedia = require("../hooks/use-media");

var _deviceNameStrategy;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DeviceNameBool = {
  MOBILE: [true, false, false],
  TABLET: [false, true, false],
  DESKTOP: [false, false, true]
};
var deviceNameStrategy = (_deviceNameStrategy = {}, _defineProperty(_deviceNameStrategy, DeviceNameBool.MOBILE, _const.DeviceName.MOBILE), _defineProperty(_deviceNameStrategy, DeviceNameBool.TABLET, _const.DeviceName.TABLET), _defineProperty(_deviceNameStrategy, DeviceNameBool.DESKTOP, _const.DeviceName.DESKTOP), _deviceNameStrategy);

var getDeviceName = function getDeviceName() {
  var temp = [(0, _useMedia.useMedia)(_const.Breakpoints.MOBILE), (0, _useMedia.useMedia)(_const.Breakpoints.TABLET), (0, _useMedia.useMedia)(_const.Breakpoints.DESKTOP)];
  return deviceNameStrategy[temp] ? deviceNameStrategy[temp] : _const.DeviceName.DESKTOP;
};

exports.getDeviceName = getDeviceName;